var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("normalDialog", {
    attrs: {
      width: "680",
      maxWidth: "680",
      title: _vm.$t(
        "label_essweb_RosterTemplate_form_dialog_editShiftTemplateMapping"
      ),
      dialog: _vm.show,
    },
    on: { close: _vm.closePorpertyDialog },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "v-form",
              { ref: "form", attrs: { "lazy-validation": "" } },
              [
                _c(
                  "v-row",
                  { attrs: { dense: "" } },
                  [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          xs: "12",
                          sm: "12",
                          md: "12",
                          lg: "12",
                          cols: "12",
                        },
                      },
                      [
                        _c("AutoComplete", {
                          attrs: {
                            isRequired: "",
                            label:
                              "label_essweb_RosterTemplate_form_dialog_shiftNameLabel",
                            items: _vm.AllShift,
                            "item-text": "shift_name",
                            "item-value": "uuid",
                            "deletable-chips": "",
                            "two-line": "",
                            rules: _vm.$GetRules(["_Require_Rules"], [null]),
                            filled: "",
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "item.subtitle",
                              fn: function (ref) {
                                var data = ref.data
                                return [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$timeMachine(
                                          data.item.start_utc_time
                                        )
                                      ) +
                                      "-" +
                                      _vm._s(
                                        _vm.$timeMachine(data.item.end_utc_time)
                                      ) +
                                      " "
                                  ),
                                ]
                              },
                            },
                          ]),
                          model: {
                            value: _vm.shift_uuid,
                            callback: function ($$v) {
                              _vm.shift_uuid = $$v
                            },
                            expression: "shift_uuid",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c("CardActions", {
              attrs: { saveBtn: "" },
              on: { save: _vm.toSave, cancel: _vm.closePorpertyDialog },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }